import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
    fetchChannel,
    fetchChannelSuccess,
    fetchChannelFailure,
    getChannel,
    getChannelSuccess,
    getChannelFailure,
    updateChannel,
    updateChannelSuccess,
    updateChannelFailure,
    deleteChannel,
    deleteChannelSuccess,
    deleteChannelFailure,
    addChannel,
    addChannelSuccess,
    addChannelFailure
} from './channel.actions';
import { of } from 'rxjs';
import { map, mergeMap, catchError, tap } from 'rxjs/operators';
import { ChannelService, PageService } from '@services/index';

@Injectable()
export class ChannelEffects {
  loadChannel$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchChannel),
      mergeMap(action =>
        this.channelService.getChannels(action.page, action.filterOptions).pipe(
          map(res => {
            return fetchChannelSuccess({ channel: res });
          }),
          catchError(error => {
            return of(fetchChannelFailure({ error }));
          })
        )
      )
    )
  );

  getChannel$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getChannel),
      mergeMap(action =>
        this.channelService.getChannel(action.id).pipe(
          map(res => {
            return getChannelSuccess({ channel: res });
          }),
          catchError(error => {
            return of(getChannelFailure({ error }));
          })
        )
      )
    )
  );

  addChannel$ = createEffect(() =>
  this.actions$.pipe(
    ofType(addChannel),
    mergeMap(action =>
      this.channelService.insertChannel(action.channel).pipe(
        map(channel => {
          return addChannelSuccess({ channel });
        }),
        tap(res => {
          this.pageService.onNotificationToggle({ show: true, error: false, message: 'Channel Added Successfully!' });
          this.channelService.fetchChannels(1, action.filterOptions || {}); 
        }),
        catchError(error => {
          this.pageService.onNotificationToggle({ show: true, error: true, message: 'Something Went Wrong!' });
          return of(addChannelFailure({ error }));
        })
      )
    )
  )
);

  updateChannel$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateChannel),
      mergeMap(action =>
        this.channelService.renewChannel(action.channel).pipe(
          map(channel => {
            return updateChannelSuccess({ channel });
          }),
          tap(res => {
            this.pageService.onNotificationToggle({ show: true, error: false, message: 'Channel Updated Successfully!' });
            this.channelService.fetchChannels(1, action.filterOptions || {}); 
          }),
          catchError(error => {
            this.pageService.onNotificationToggle({ show: true, error: true, message: 'Something Went Wrong!' });
            return of(updateChannelFailure({ error }));
          })
        )
      )
    )
  );

  deleteChannel$ = createEffect(() =>
  this.actions$.pipe(
    ofType(deleteChannel),
    mergeMap(action =>
      this.channelService.removeChannel(action.id).pipe(
        map(() => {
          return deleteChannelSuccess({ id: action.id });
        }),
        tap(res => {
          this.channelService.fetchChannels(1, action.filterOptions || {});
        }),
        catchError(error => {
          // this.sharedService.onLoaderToggle(false);
          return of(deleteChannelFailure({ error }));
        })
      )
    )
  )
);


  constructor(
    private actions$: Actions,
    private channelService: ChannelService,
    private pageService: PageService
  ) {}
}
